var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modalId,"hide-footer":true,"size":_vm.size,"title":_vm.modalTitle}},[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }